<template>
  <div class="news">
    <!-- 导航栏 -->
    <van-nav-bar title="我的消息" left-arrow @click-left="onBack">
      <template #left>
        <van-icon name="arrow-left" size=".7rem" color="#FF9D11" />
      </template>
    </van-nav-bar>
    <!-- 内容 -->
    <div class="news-wrapper">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div v-for="(item,index) in list" :key="index" class="new-block">
          <p class="title" @click="goNewDetail(item.new_id)">{{item.title}}</p>
          <p class="time">{{item.time}}</p>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { contTools } from "@/mixins/contMixins";
import wapApiFun from "@/servers/wap-module/apiFun";
import comTools from "@/assets/js/until";
export default {
  name: "news",
  mixins: [contTools],
  components: {},
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1,
      cont:''
    };
  },
  watch: {},
  computed: {},
  created() {
    // this.initData();
  },
  methods: {
    // 数据初始化
    onLoad() {
      // 异步更新数据
      let data = comTools.assignObj(this.wapConfig(), {
        mobile: this.$cookies.get("mobile"),
        user_token: this.$cookies.get("userToken"),
        page: this.page
      });
      data.sign = comTools.querySort(data);
      wapApiFun.news(data).then(res => {
        if (res.code == 200) {
          console.log("记录列表", res);
          let resData = res.data;
          this.list = this.list.concat(resData.list);
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (this.list.length >= resData.total) {
            this.finished = true;
            console.log("数据全部加载完成");
          }
          this.page++;
        } else {
          this.$toast("网路出错");
        }
      });
    },
    // 跳转详情
    goNewDetail(id) {
      // this.cont = cont;
      this.$router.push({
        name: "newDetails",
        query:{newid:id}
      });
    },
    onBack() {
      this.$router.go(-1);
    }
  },
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/com.less";
.news {
  width: 100%;
  height: 100vh;
  background-color: #f9f9f9;
  padding-bottom: 1rem;
  .news-wrapper {
    .new-block {
      width: 90%;
      min-height: 2rem;
      margin: 0 auto;
      background-color: #fff;
      .borderRadius(0.2rem);
      .boxShadow(1px);
      // border: 1px solid #fff;
      margin-bottom: 0.5rem;

      .title {
        padding: 0.3rem;
        .ellipsis();
      }
      .time {
        .font-color();
        font-size: 0.3rem;
        padding: 0.3rem;
      }
      &:first-child {
        margin-top: 0.5rem;
      }
    }
  }
}
</style>